var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gaugeContainer",staticClass:"radial-gauge-container"},[(_vm.value === null || _vm.value === undefined)?_c('div',{staticClass:"no-data"},[_vm._t("no-data",function(){return [_vm._v("No data")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }